import { useEffect, useMemo, useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../configs/translations'
import { useMdfActivitiesRefresh } from '../../hooks/useMdfActivitiesRefresh'
import { formatMdfSyncTime } from '../../lib'

const SYNC_TIME_UPDATE_INTERVAL_MS = 30_000
const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.dashboard.refresh

interface IMdfActivitiesRefreshButtonProps {
  partnerId: string
}

export const MdfActivitiesRefreshButton = ({ partnerId }: IMdfActivitiesRefreshButtonProps) => {
  const { isRefreshing, lastSyncTime, refreshMdfActivities } = useMdfActivitiesRefresh(partnerId)
  const [now, setNow] = useState(Date.now)

  useEffect(() => {
    setNow(Date.now())

    if (lastSyncTime === null) {
      return
    }

    const intervalId = window.setInterval(() => setNow(Date.now()), SYNC_TIME_UPDATE_INTERVAL_MS)

    return () => window.clearInterval(intervalId)
  }, [lastSyncTime])

  const syncTime = useMemo(
    () => (lastSyncTime === null ? null : formatMdfSyncTime(lastSyncTime, now)),
    [lastSyncTime, now]
  )

  return (
    <Tooltip
      inline
      disabled={syncTime === null}
      tipContent={() => (
        <Translation
          text={KEYS.tooltip}
          replaceParams={[{ key: '{syncTime}', value: syncTime ?? '' }]}
          span
        />
      )}
    >
      <Button
        variant={'outlined'}
        color={'grey'}
        icon={'kbase kbase-reload'}
        loading={isRefreshing}
        onClick={() => void refreshMdfActivities()}
      >
        <Translation text={KEYS.button} span />
      </Button>
    </Tooltip>
  )
}

MdfActivitiesRefreshButton.displayName = 'MdfActivitiesRefreshButton'
